import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { Sky } from './objects/Sky.js';

import snowVertexShader from './shaders/snow/vertex.glsl'
import snowFragmentShader from './shaders/snow/fragment.glsl'



function loaded() {
  document.getElementById('loader-container').style.display = 'none';
  document.getElementById('content').style.display = 'block';
  resizeCanvas();
}

// **********
//     3D
// **********

// Canvas
const canvas = document.querySelector('canvas.webgl')
const scratchCanvas = document.querySelector('canvas.canvas-scratch')

// Scene
const scene = new THREE.Scene()

/**
 * Loaders
 */

// Texture loader
const textureLoader = new THREE.TextureLoader()

// Draco loader
const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('draco/')

// GLTF loader
const gltfLoader = new GLTFLoader()
gltfLoader.setDRACOLoader(dracoLoader)

/**
 * Textures
 */

const windowMaterial = new THREE.MeshBasicMaterial({ color: 0xCFB253 })
const stringLightMaterial = new THREE.MeshBasicMaterial({ color: 0x0000000 })
const bulbRedMaterial = new THREE.MeshStandardMaterial({
  color: 0xb50021,
  emissive: 0xb50021,
  emissiveIntensity: 1,
  metalness: 0.2,
  roughness: 0.5
});

const bulbGreenMaterial = new THREE.MeshStandardMaterial({
  color: 0x087a00,
  emissive: 0x087a00,
  emissiveIntensity: 1,
  metalness: 0.2,
  roughness: 0.5
});

const materialfish = new THREE.MeshBasicMaterial( {color: 0x000000, side: THREE.DoubleSide} );

const bakedTextureAccesory = textureLoader.load('accesory.jpg')
bakedTextureAccesory.encoding = THREE.sRGBEncoding
bakedTextureAccesory.flipY = false
const bakedMaterialAccesory = new THREE.MeshBasicMaterial({ map: bakedTextureAccesory })

const bakedTextureHouse = textureLoader.load('House_wall.jpg')
bakedTextureHouse.encoding = THREE.sRGBEncoding
bakedTextureHouse.flipY = false
const bakedMaterialHouse = new THREE.MeshBasicMaterial({ map: bakedTextureHouse })

const bakedTextureTree = textureLoader.load('tree.jpg')
bakedTextureTree.encoding = THREE.sRGBEncoding
bakedTextureTree.flipY = false
const bakedMaterialTree = new THREE.MeshBasicMaterial({ map: bakedTextureTree })

const bakedTextureSleigh = textureLoader.load('Sleigh_gift.jpg')
bakedTextureSleigh.encoding = THREE.sRGBEncoding
bakedTextureSleigh.flipY = false
const bakedMaterialSleigh = new THREE.MeshBasicMaterial({ map: bakedTextureSleigh })

const icingMaterial = new THREE.MeshPhysicalMaterial({
  color: 0xffffff,
  roughness: 0.3,
  metalness: 0,
  clearcoat: 0.5,
  clearcoatRoughness: 0.1,
});

/**
 * Model
 */

// Accesory
gltfLoader.load(
    'accesory.glb',
    (gltf) =>
    {
        gltf.scene.traverse((child) =>
        {
            child.material = bakedMaterialAccesory
        })
        scene.add(gltf.scene)
    }
)
// // Accesory
gltfLoader.load(
  'sleigh_gift.glb',
  (gltf) =>
  {
      gltf.scene.traverse((child) =>
      {
          child.material = bakedMaterialSleigh
      })
      scene.add(gltf.scene)
  }
)


// Gingerbread house
gltfLoader.load(
  'house_wall.glb',
  (gltf) =>
  {
      gltf.scene.traverse((child) =>
      {
          child.material = bakedMaterialHouse
      })
      scene.add(gltf.scene)
  }
)

// icing
gltfLoader.load(
  'icing.glb',
  (gltf) =>
  {
      gltf.scene.traverse((child) =>
      {
          child.material = icingMaterial
      })
      scene.add(gltf.scene)
  }
)

// trees
gltfLoader.load(
  'tree.glb',
  (gltf) =>
  {
      gltf.scene.traverse((child) =>
      {
          child.material = bakedMaterialTree
      })
      scene.add(gltf.scene)
      loaded()
  }
)


// window
gltfLoader.load(
  'windows.glb',
  (gltf) =>
  {
      gltf.scene.traverse((child) =>
      {
          child.material = windowMaterial
      })
      scene.add(gltf.scene)
  }
)

const EvenBulb = []
const OddBulb = []
// String light
gltfLoader.load(
  'string_light.glb',
  (gltf) =>
  {
      gltf.scene.traverse((child) =>
      {
        if(child.name.startsWith('Cube') || child.name.startsWith('Bezier'))
        {
          child.material = stringLightMaterial
        }
        else if(child.name.startsWith('Sphere'))
          {
            const number = parseInt(child.name.replace(/\D/g, ''), 10); 
            if(number % 2 === 0)
            { 
              child.material = bulbRedMaterial
              EvenBulb.push(child)
            }
            else {
              OddBulb.push(child)
              child.material = bulbGreenMaterial
            }
            // child.material = fireLightMaterial

          }
      })
      scene.add(gltf.scene)
  }
)

/**
 * Sun
 */
const sun = new THREE.Vector3();

const sky = new Sky();
sky.scale.setScalar( 200 );

scene.add( sky );
              
const skyUniforms = sky.material.uniforms;
              
skyUniforms[ 'turbidity' ].value = 0;
skyUniforms[ 'rayleigh' ].value = 0.08;
skyUniforms[ 'mieCoefficient' ].value = 0.0;
skyUniforms[ 'mieDirectionalG' ].value = 0.8;
              
const parameters = {
    elevation: 6,
    azimuth: 120,
};

const debugObject = {}

debugObject.depthColor = '#e0e0e0'
debugObject.surfaceColor = '#dbdbdb'
debugObject.centerColor = '#fff8e5'
debugObject.outerColor = '#a3a3a3'

/**
 * SnowFloor
 */
const SnowFloorGeometry = new THREE.PlaneGeometry(200, 200, 128, 128);
const SnowFloorMaterial = new THREE.ShaderMaterial({
  vertexShader: snowVertexShader,
  fragmentShader: snowFragmentShader,
  uniforms:
  {
      uSmallWavesElevation: { value: 0.15 },
      uSmallWavesFrequency: { value: 3 },
      uSmallIterations: { value: 4 },
      uDepthColor: { value: new THREE.Color(debugObject.depthColor) },
      uSurfaceColor: { value: new THREE.Color(debugObject.surfaceColor) },
      uCenterColor: { value: new THREE.Color(debugObject.centerColor) },
      uOuterColor: { value: new THREE.Color(debugObject.outerColor) },
      uColorOffset: { value: 0.08 },
      uColorMultiplier: { value: 8 }
  }
})

const SnowFloor = new THREE.Mesh( SnowFloorGeometry, SnowFloorMaterial );

SnowFloor.rotation.x = - Math.PI / 2;
scene.add( SnowFloor );

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(45, sizes.width / sizes.height, 0.1, 100)
camera.position.x = -20
camera.position.y = 4.025
camera.position.z = 10.25
scene.add(camera)

// Controls
// const controls = new OrbitControls(camera, scratchCanvas)
const controls = new OrbitControls(camera, scratchCanvas)

controls.maxPolarAngle = Math.PI * 0.480;
controls.minDistance = 20.0;
controls.maxDistance = 30.0;
controls.enableDamping = true
controls.enabled = false;

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.outputEncoding = THREE.sRGBEncoding
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.toneMapping = THREE.ACESFilmicToneMapping;
				renderer.toneMappingExposure = 0.4;


const pmremGenerator = new THREE.PMREMGenerator( renderer );
let renderTarget;
              
function updateSun() {          
    const phi = THREE.MathUtils.degToRad( 90 - parameters.elevation );
    const theta = THREE.MathUtils.degToRad( parameters.azimuth );
              
    sun.setFromSphericalCoords( 1, phi, theta );
              
    sky.material.uniforms[ 'sunPosition' ].value.copy( sun );
    if ( renderTarget !== undefined ) renderTarget.dispose();
    renderTarget = pmremGenerator.fromScene( sky );              
    scene.environment = renderTarget.texture;          
}

updateSun();

const light = new THREE.AmbientLight( 0x404040, 1.5); // soft white light
scene.add( light );

/**
 * Animate
 */
const clock = new THREE.Clock()

const colorChangeInterval = 0.5;
let lastToggleTime = 0;

const tick = () =>
{
    // console.log('camera.position ', camera.position)
    const elapsedTime = clock.getElapsedTime()

    if (elapsedTime - lastToggleTime >= colorChangeInterval) {
      EvenBulb.forEach(bulb => {
          bulb.material = bulb.material === bulbRedMaterial ? bulbGreenMaterial : bulbRedMaterial;
      });

      OddBulb.forEach(bulb => {
          bulb.material = bulb.material === bulbGreenMaterial ? bulbRedMaterial : bulbGreenMaterial;
      });

      lastToggleTime = elapsedTime; // Update the last toggle time
    }

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()

// *************
//     SCRATCH
// *************

const ctx = scratchCanvas.getContext('2d', { willReadFrequently: true });
const clearBtn = document.getElementById("clearCanvas");


function resizeCanvas() {
  const devicePixelRatio = window.devicePixelRatio || 1;

  // Set the canvas resolution for high-DPI displays
  scratchCanvas.width = window.innerWidth * devicePixelRatio;
  scratchCanvas.height = window.innerHeight * devicePixelRatio;

  // Set the displayed size of the canvas (for normal resolution)
  scratchCanvas.style.width = window.innerWidth + 'px';
  scratchCanvas.style.height = window.innerHeight + 'px';

  // Scale the context to match the device's pixel ratio
  ctx.scale(devicePixelRatio, devicePixelRatio);

  // Create the gradient background
  const gradient = ctx.createLinearGradient(0, 0, scratchCanvas.width, scratchCanvas.height);
  gradient.addColorStop(0, "#FB7C8D");
  gradient.addColorStop(0.45, "#82A96E");

  // Apply the gradient as the background
  ctx.fillStyle = gradient;
  ctx.fillRect(0, 0, scratchCanvas.width, scratchCanvas.height);

  // Enable image smoothing for smoother rendering
  ctx.imageSmoothingEnabled = true;

  // Set the font
  ctx.font = "70px NTFabulous";
  ctx.fillStyle = "#0a4703";

  // Split the text into lines
  const line1 = "MERRY";
  const line2 = "CHRISTMAS";
  const line3 = "touch or click to display the scene";

  const line4 = "touch or click"
  const line5 = "to display the scene"



  // Measure the text width for each line
  const textWidth1 = ctx.measureText(line1).width;
  const textWidth2 = ctx.measureText(line2).width;

  // Use the font size as an approximation for line height
  const textHeight = 50;

  // Calculate the positions to center the text
  const x1 = (window.innerWidth - textWidth1) / 2;
  const x2 = (window.innerWidth - textWidth2) / 2;

  // Adjust the vertical spacing between the two lines
  const y1 = (window.innerHeight - textHeight) / 2;
  const y2 = y1 + textHeight + 10; // 10px gap between lines

  // Draw each line of text
  ctx.fillText(line1, x1, y1);
  ctx.fillText(line2, x2, y2);

  // Smaller font for the third line
  ctx.font = "30px NTFabulous";
  const textWidth3 = ctx.measureText(line3).width;
  if (textWidth3 > window.innerWidth) {
    const textWidth4 = ctx.measureText(line4).width;
    const textWidth5 = ctx.measureText(line5).width;

    const x4 = (window.innerWidth - textWidth4) / 2;
    const x5 = (window.innerWidth - textWidth5) / 2;

    ctx.fillText(line4, x4, y2 + 50);
    ctx.fillText(line5, x5, y2 + 80);
  } else {
    const x3 = (window.innerWidth - textWidth3) / 2;
    ctx.fillText(line3, x3, y2 + 50);
  }
}

resizeCanvas();

window.addEventListener("resize", resizeCanvas);

// Variables for drawing
let isDrawing = false;
let lastX = 0;
let lastY = 0;

// Start drawing
scratchCanvas.addEventListener("mousedown", (e) => {
  const rect = scratchCanvas.getBoundingClientRect();
  const x = (e.clientX - rect.left) * devicePixelRatio;
  const y = (e.clientY - rect.top) * devicePixelRatio;
  isDrawing = true;
  [lastX, lastY] = [e.offsetX, e.offsetY];


      // Get pixel data at the clicked position
      const pixel = ctx.getImageData(x, y, 1, 1).data;
      controls.enabled = false
      // If the alpha value of the pixel is 0 (transparent), route event to WebGL canvas

    if (pixel[3] === 0) {
      controls.enabled = true; 
      isDrawing = false
    }
});

scratchCanvas.addEventListener("mouseup", () => {    isDrawing = false
    controls.enabled = false
});
scratchCanvas.addEventListener("mouseout", () => {    isDrawing = false
    controls.enabled = false
});

// Draw on scratchCanvas
scratchCanvas.addEventListener("mousemove", (e) => {
  if (!isDrawing) {
    controls.enabled = true;
    return
  }
  ctx.globalCompositeOperation = "destination-out";
  ctx.lineWidth = 80;
  ctx.lineJoin = "round";
  ctx.beginPath();
  ctx.moveTo(lastX, lastY);
  ctx.lineTo(e.offsetX, e.offsetY);
  ctx.closePath();
  ctx.stroke();
  [lastX, lastY] = [e.offsetX, e.offsetY];
});

// Touch events for mobile
scratchCanvas.addEventListener("touchstart", (e) => {
  const touch = e.touches[0];

  // Get canvas position relative to the document
  const rect = scratchCanvas.getBoundingClientRect();
  const x = (touch.clientX - rect.left) * devicePixelRatio;
  const y = (touch.clientY - rect.top) * devicePixelRatio;
  
  // Get pixel data at the touched position
  const pixel = ctx.getImageData(x, y, 1, 1).data;
  
  controls.enabled = false;
        if (pixel[3] === 0) {
          controls.enabled = true;
          isDrawing = false;
          return;
        }

  isDrawing = true;
  [lastX, lastY] = [touch.clientX, touch.clientY];
  e.preventDefault();
});

scratchCanvas.addEventListener("touchend", () => {
    isDrawing = false
    // controls.enabled = false
});
scratchCanvas.addEventListener("touchmove", (e) => {
    if (!isDrawing) {
        controls.enabled = true;
        
        controls.enablePan = false; 
        return
      }
  const touch = e.touches[0];
  ctx.globalCompositeOperation = "destination-out";
  ctx.lineWidth = 80;
  ctx.lineJoin = "round";
  ctx.beginPath();
  ctx.moveTo(lastX, lastY);
  ctx.lineTo(touch.clientX, touch.clientY);
  ctx.closePath();
  ctx.stroke();
  [lastX, lastY] = [touch.clientX, touch.clientY];
  e.preventDefault();
});

// // Clear scratchCanvas
clearBtn.addEventListener("click", () => {
  ctx.globalCompositeOperation = "source-over";
  resizeCanvas();
});

